import getCitiesService from 'owa-calendar-scheduling-service/lib/services/getCitiesService';
import { isSuccessStatusCode } from 'owa-http-status-codes';

export default function getCities(): Promise<string[] | null> {
    return getCitiesService().then(response => {
        if (!isSuccessStatusCode(response.status)) {
            return Promise.resolve(null);
        }
        return response.json().then(roomsResult => roomsResult?.value);
    });
}
